import React, { PureComponent } from 'react';
import { Row, Col } from 'react-bootstrap';
import axios from 'axios';
import appConstant from '../../../../constants/app';
import {PageView, Event} from '../../../components/baseComponents/Tracking';

class TrendingLinks extends PureComponent {
  state = {
    links: [],
  }

  componentDidMount() {
    axios.get(`${appConstant.API_URL}/link/trending`)
      .then(res => {
        const links = res.data.links;
        this.setState({
          links,
        });
      }).catch(err => {
        console.log(err);
      });

      PageView();
  }

  onClickTrendingLink = (e, linkId, linkLabel) => {
    Event("Links", "Click", linkLabel)

    axios({
      method: 'post',
      url: `${appConstant.API_URL}/link/click`, 
      data: {
        id: linkId,
      },
    })
    .then(res => {
    }).catch(err => {
      console.log(err);
    });
  }

  render() {
    const {
      links,
    } = this.state;

    return (
      <Row>
        <Col className="links-list-wrapper">
          {links.map((link, index) => {

            return (
              <div className="link-wrapper" key={`list-${link.id}`}>
                <a className="link"
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => {
                    this.onClickTrendingLink(e, link.id, link.label)
                  }}
                  title={link.label}
                >
                  <div className="link-wrapper-content">
                    <div className="img-wrapper">
                      <img alt="" src={link.icon.icon_path} />
                    </div>
                    <div
                      style={{
                        width: '80%',
                      }}
                    >
                      <p>
                        {link.label.length > 25 ? `${link.label.substr(0, 22)}...` : link.label }
                      </p>
                    </div>
                  </div>
                </a>
              </div>
            )
          })}
        </Col>
      </Row>
    );
  }
}

export default TrendingLinks;



// WEBPACK FOOTER //
// ./src/app/screens/landing/links/trendingLinks.js